import React from "react";
import { HeaderProps } from "./types";

export function Header({ onFinancialAidClick }: HeaderProps) {
  const handleFeedbackClick = () => {
    window.open('https://forms.office.com/r/w2MVD1WxYH', '_blank');
  };

  return (
    <header className="sticky top-0 px-0 py-1 sm:py-4 border-b border-solid bg-[#ffffff] border-b-[#e6e6e6] shadow-[0_1px_3px_rgba(0,0,0,0.1)] text-[#1b2c5a] z-[1000]">
      <div className="flex gap-1 sm:gap-4 items-center justify-between px-2 sm:px-4 py-0 mx-auto my-0 max-w-[1200px] max-sm:flex-row max-sm:gap-1">
        <div className="flex gap-1 sm:gap-4 items-center">
          <div className="flex overflow-hidden relative justify-center items-center w-24 sm:w-40 h-18 sm:h-30 bg-[#ffffff]">
            <img
              src="/FSEP_CPP_Logo.png"
              alt="Forward Sumner Logo"
              className="object-contain p-0.5 sm:p-1.5 w-full h-auto max-h-full"
            />
          </div>
        </div>
        <div className="flex gap-1 sm:gap-3 items-center">
          <button
            onClick={handleFeedbackClick}
            className="px-2 sm:px-4 py-1 sm:py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 text-xs sm:text-sm font-medium flex items-center gap-0.5 sm:gap-2 shadow-md hover:shadow-lg"
          >
            <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            <span className="hidden sm:inline">Feedback</span>
          </button>
          <button
            onClick={onFinancialAidClick}
            className="px-3 sm:px-6 py-1.5 sm:py-3 bg-gradient-to-r from-[#d5a32a] to-[#f2c94c] text-[#ffffff] rounded-lg sm:rounded-xl hover:from-[#f2c94c] hover:to-[#d5a32a] transition-all duration-200 text-xs sm:text-base font-semibold flex items-center gap-1 sm:gap-3 shadow-lg hover:shadow-xl font-['Roboto'] header-financial-aid-button"
          >
            <svg className="w-4 h-4 sm:w-8 sm:h-8" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              {/* Graduation cap */}
              <polygon points="32,8 8,20 32,32 56,20 32,8" />
              <rect x="24" y="32" width="16" height="8" rx="2" />
              <line x1="32" y1="32" x2="32" y2="44" />
              {/* Tassel */}
              <line x1="48" y1="20" x2="48" y2="32" />
              <circle cx="48" cy="34" r="2" />
              {/* Dollar sign in a circle */}
              <circle cx="32" cy="52" r="10" />
              <path d="M32 47v10" />
              <path d="M28.5 50C28.5 48.5 30 47.5 32 47.5C34 47.5 35.5 48.5 35.5 50C35.5 51.5 34 52.5 32 52.5C30 52.5 28.5 53.5 28.5 55C28.5 56.5 30 57.5 32 57.5C34 57.5 35.5 56.5 35.5 55" />
            </svg>
            <span className="hidden sm:inline">Financial Aid</span>
            <span className="sm:hidden">Aid</span>
          </button>
        </div>
      </div>
    </header>
  );
}
